import { GraduationCap } from "lucide-react";
import { Button } from "../ui/button";

const LINKS = [
    { label: "Lessons", href: "#lessons" },
    { label: "Countries", href: "#countries" },
    { label: "Teacher", href: "#teacher" },
    { label: "About", href: "#about" },
    { label: "FAQ", href: "#faq" },
];

export const Navbar = () => (
    <header className="sticky top-0 z-40 border-b border-ground-line/60 bg-ground-deep/85 backdrop-blur-md">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
            <a href="#top" data-testid="nav-brand-link" className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-sun text-ground-deep shadow-lg shadow-sun/20">
                    <GraduationCap className="h-6 w-6" strokeWidth={2.2} />
                </span>
                <span className="flex flex-col leading-tight">
                    <span className="font-heading text-xl font-extrabold tracking-tight text-ink">
                        YNova <span className="text-sun">Education</span>
                    </span>
                    <span className="text-[10px] font-semibold tracking-wide text-mist uppercase">
                        Better English. Brighter Future.
                    </span>
                </span>
            </a>
            <nav className="hidden items-center gap-7 lg:flex" data-testid="nav-links">
                {LINKS.map((link) => (
                    <a
                        key={link.href}
                        href={link.href}
                        data-testid={`nav-link-${link.label.toLowerCase()}`}
                        className="text-sm font-medium text-mist transition-colors duration-200 hover:text-sun"
                    >
                        {link.label}
                    </a>
                ))}
            </nav>
            <Button asChild className="rounded-full font-semibold shadow-lg shadow-sun/20 transition-transform duration-200 hover:scale-105">
                <a href="#contact" data-testid="nav-send-enquiry-btn">Send an Enquiry</a>
            </Button>
        </div>
    </header>
);
